<template>
  <div>
    <v-btn
      outlined
      color="primary"
      v-if="isEmpty && showButton"
      @click="action"
    >
      {{ buttonTitle }}
    </v-btn>
    <widget
      v-else-if="!widgetType"
      v-bind="{...model, ...widgetProps}"
      @click="action"
    ></widget>
    <custom-widget
      v-else
      v-bind="{...model, ...widgetProps}"
      @click="action"
    >
    </custom-widget>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {_} from 'vue-underscore';
  import {FlowGeneratorBus} from "../../plugins/bus"
  import {ComponentWithModelMixin} from "../../mixins/FlowGenerator";

  export default {
    name: "VuexStateWidget",
    mixins: [ComponentWithModelMixin],
    props: {
      getter: {
        type: String,
        default: undefined
      },
      widgetType: {
        type: [Function, undefined],
        default: undefined,
        description: "Your custom component path to file"
      },
      widgetProps: {
        type: Object,
        default: () => ({}),
        description: "Bind this object data to props of the custom widget"
      },
      actionEventName: {
        type: String,
        default: '',
        description: 'Event keyword to trigger with EventBus'
      },
      buttonTitle: {
        type: String,
        default: "Change"
      },
      showButton: {
        type: Boolean,
        default: true
      },
    },
    components: {
      'widget': () => import("./CheckboxCard")
    },
    mounted() {
      const widgetPath = this.widgetType
      if (widgetPath) {
        Vue.component('custom-widget', widgetPath)
      }
    },
    computed: {
      getterProps() {
        try {
          if (this.getter) {
            return this.$store.getters[this.getter]
          }
        } catch (e) {
          console.log(e)
        }
        return {}
      },
      isEmpty() {
        return _.isEmpty(this.model)
      }
    },
    watch: {
      'getterProps': function (newval, oldval) {
        if (newval && oldval !== newval) {
          this.$emit('input', newval)
          this.model = newval
        }
      }
    },
    methods: {
      action() {
        FlowGeneratorBus.$emit(this.actionEventName)
      }
    }

  }
</script>

<style scoped>

</style>